import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
  pageTitle: {
    fontSize: 26,
    fontWeight: 300
  },
  eventIcon: {
    color: 'grey'
  },
  pageContentDIv: {
    //marginTop:30,
    padding: 24,
    height: 'calc(100vh - 115px)',
    overflow: 'auto'
  },
  indicator:{
    color:"#c4c4c4",
    fontSize:10,
    margin:"0px 8px"
  },
  txType:{
    fontSize:10,
    color:'#0033cc',
    fontWeight:600,
  },
  pageContentDIvTrip: {
    padding: 24,
    paddingTop: 0,
    height: 'calc(100vh - 115px)',
    overflow: 'auto'
  },
  addPartyCta: {
    backgroundColor: '#0033cc',
    borderRadius: 4,
    border: 0,
    color: 'white',
    height: 36,
    padding: '7px 16px 7px 12px',
    margin: '0 16px',
    textTransform: 'capitalize'
  },
  viewPDFCta: {
    backgroundColor: '#f27f36',
    borderRadius: 4,
    border: 0,
    color: 'white',
    height: 36,
    padding: '7px 16px 7px 12px',
    margin: '0 16px',
    textTransform: 'capitalize',
    "&:hover": {
      backgroundColor: '#f27f36',
    }
  },
  addTripCta: {
    backgroundColor: '#00875a',
    borderRadius: 4,
    border: 0,
    color: 'white',
    height: 36,
    padding: '7px 26px 7px 12px',
    margin: '0 16px',
    textTransform: 'capitalize'
  },
  infoCard: {
    width: 269,
    height: 90,
    padding: "12px 24px"
  },
  infoCard1: {
    padding: "12px 24px",
    minWidth: "296px",
    boxShadow: 'none',
    border: '1px solid lightgray'
  },
  infoCardTitle: {
    color: '#6b778c',
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 500,
    marginBottom: 6,
    letterSpacing: '0.02em'
  },
  infoCardTitle1: {
    color: '#6b778c',
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 500,
    marginBottom: 4,
    letterSpacing: '0.02em'
  },
  infoCardTitle2: {
    color: '#6b778c',
    fontSize: 12,
    textTransform: 'uppercase',
    fontWeight: 500,
    marginRight: 12,
    letterSpacing: '0.02em'
  },
  infoCardIcon: {
    fontSize: 16,
    color: '#A8A8A8',
    float: 'right',
    // marginTop: 4
  },
  infoPartyBalance: {
    color: '#de1c22',
    fontSize: 30,
    textTransform: 'uppercase',
    fontWeight: 300
  },
  circle: {
    borderRadius: "50%",
    backgroundColor: "#2d9d78",
    fontSize: 8,
    color: "#2d9d78",
  },
  circleOnTrip: {
    borderRadius: "50%",
    backgroundColor: "#2680eb",
    fontSize: 8,
    color: "#2680eb",
  },
  truckNoDiv: {
    display: 'flex', alignItems: 'center', fontWeight: 300
  },
  mlV1: {
    marginLeft: '4px'
  },
  divTruckNoSuffix: {
    marginLeft: '4px', color: '#0033cc'
  },
  fw300: {
    fontWeight: 300
  },
  statusV1: {
    marginLeft: 6, fontWeight: 300, textTransform: 'capitalize'
  },
  statusDiv: {
    display: 'flex', alignItems: 'center'
  },
  divLocation: {
    display: 'flex', alignItems: 'center', fontWeight: 300
  },
  arrowRightV1: {
    marginTop: '-1px', color: '#A0A0A0'
  },
  marketTruck: {
    color: '#f27f36',
    fontSize: 30,
    fontWeight: 300
  },
  myTruck: {
    color: '#00875a',
    fontSize: 30,
    fontWeight: 300
  },
  allTruck: {
    fontSize: 30,
    fontWeight: 300
  },
  infoActiveTrip: {
    color: '#00875a',
    fontSize: 30,
    textTransform: 'uppercase',
    fontWeight: 300
  },
  infoActiveSupplier: {
    color: '#f27f36',
    fontSize: 30,
    textTransform: 'uppercase',
    fontWeight: 300
  },
  balance: {
    color: '#0033cc',
    textAlign: 'right'
  },
  divText: {
    textAlign: 'right'
  },
  supplierBalance: {
    color: '#de1c22'
  },
  monthlyBalance: {
    color: 'blue'
  },
  balanceV1: {
    fontSize: 24, fontWeight: 300, marginLeft: 10
  },
  profit: {
    color: '#00875a',
    fontSize: '24px',
  },
  loss: {
    color: '#de1c22',
    fontSize: '24px',
  },
  divAmount: {
    fontSize: 12, color: '#6b778c', fontWeight: 500, textTransform: 'uppercase'
  },
  divV14: {
    width: '70%', marginTop: '16px', backgroundColor: '#f1f1f3', paddingTop: '10px', paddingBottom: '11px', paddingLeft: '16px'
  },
  divV7: {
    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: '21px'
  },
  confirmV1: {
    backgroundColor: 'black',
    color: 'white',
    textTransform: 'capitalize',
    fontWeight: 300,
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 9,
    paddingBottom: 11,
    "&:hover": {
      backgroundColor: 'black'
    }
  },
  cancelButton: {
    textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
    "&:hover": {
      backgroundColor: '#f6f7f9'
    }
  },
  marginV1: {
    margin: 0, marginTop: 6
  },
  mtV1: {
    marginTop: '24px'
  },
  amountV1: {
    fontWeight: 300, marginTop: 4, fontSize: 18
  },
  divDate: {
    color: '#9ea0a5', fontSize: 12, fontWeight: 500, marginTop: 16
  },
  button1: {
    textTransform: 'none',
    color: '#1976d2',
    borderRadius: '4px',
    fontWeight: 600,
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: 16,
    paddingRight: 16,
    border: 'solid 1px #1976d2',
    marginLeft: 88
  },
  divV2: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
  },
  divV3: {
    display: 'flex', alignItems: 'center',
  },
  divVRow: {
    display: 'flex', justifyContent: 'center', flexDirection: 'row', alignItems: 'center'
  },
  divV5: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between'
  },
  divV25: {
    fontWeight: 'bold', fontSize: '16px'
  },
  mtV5: {
    marginTop: '8px'
  },
  cancelV1: {
    color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
  },
  deleteV1: {
    color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
  },
  STARTED: {
    color: "#2680eb",
    fontSize: 12,
  },
  COMPLETED: {
    color: "#00875a",
    fontSize: 12,
  },
  PAYMENT_RECEIVED: {
    color: "grey",
    fontSize: 12,
  },
  POD_RECEIVED: {
    color: "#2680eb",
    fontSize: 12,
  },
  POD_SUBMITTED: {
    color: "#2680eb",
    fontSize: 12,
  },
  SETTLED: {
    color: "#00875a",
    fontSize: 12,
  },
  STARTED_BULLET: {
    color: "#2680eb",
    fontSize: 12,
  },
  COMPLETED_BULLET: {
    color: "#00875a",
    fontSize: 12,
  },
  PAYMENT_RECEIVED_BULLET: {
    color: "grey",
    fontSize: 12,
  },
  POD_RECEIVED_BULLET: {
    color: "#2680eb",
    fontSize: 12,
  },
  POD_SUBMITTED_BULLET: {
    color: "#2680eb",
    fontSize: 12,
  },
  SETTLED_BULLET: {
    color: "#00875a",
    fontSize: 12,
  },
  actionButton: {
    textTransform: 'capitalize',
    color: '#0033cc',
    borderColor: '#0033cc',
    fontSize: 12
  },
  actionPDF: {
    color: '#0033cc',
    fontSize: 16
  },
  titleBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 8,
    color: "lightgrey",
    margin: "0px 6px",
    marginTop: -2
  },
  mtV2: {
    marginTop: 2,
    marginLeft: "-5em"
  },
  mtV4: {
    marginLeft: "-5em",
    display: 'flex',
  },
  mtV3: {
    marginTop: 2,
  },
  divV1: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between'
  },
  mlV2: {
    marginLeft: 16
  },
  color1: {
    color: 'red'
  },
  arrowRightV2: {
    fontSize: 29,
    color: '#909090'
  },
  divV4: {
    display: 'flex', alignItems: 'center'
  },
  divTripStatus: {
    color: '#9ea0a5',
    fontSize: 13,
    textAlign: 'start',
    marginTop: '-20px'
  },
  divDateV1: {
    color: '#9ea0a5',
    fontSize: 13,
    textAlign: 'start',
    marginTop: '-20px'
  },
  gridContainerWidth3Cards: {
    width: '100%'
  },
  gridItemWidth3Cards: {
    minWidth: "32%"
  },
  mlV3: {
    marginLeft: 16,
    marginBottom: 8
  },
  paddingRightV1: {
    paddingRight: 8
  },
  marginBottomV1: {
    marginBottom: 8
  },
  table: {
    "& .MUIDataTable": {
      cursor: 'default'
    }
  },
  // driverTable: {
  //   '& .MuiTableRow-root': {
  //     cursor: 'default',
  //     // "&:hover": {
  //     //   backgroundColor: 'white'
  //     // }
  //   }
  // },
  monthlyBalanceTableV1: {
    '& .MuiTableRow-root': {
      cursor: 'default',
    },
    marginTop: 16
  },
  paymentsTable: {
    '& .MuiTableRow-root': {
      //cursor: 'default',
    },
    /*'& .MUIDataTableToolbar-left-205': {
      display: 'none',
    },*/
    '& div[class^="MUIDataTableToolbar-left-"]': {
      display: 'none'
    }
  },
  dividerDiv: {
    marginBottom: 8
  },
  infoV1: {
    fontSize: 13,
    color: 'grey',
    marginTop: '-3px',
    marginLeft: 6,
    cursor: 'pointer'
  },
  tripTable: {
    marginTop: 16,
    "& .MuiToolbar-root": {
      paddingTop: 16,
      paddingBottom: 16
    }
  },
  vehileNumber: {
    fontSize: 14,
    "&:last-child": {
      color: '#0033cc',
      marginLeft: 6
    },
    "&:nth-last-child(2)": {
      marginLeft: 6
    }
  },
  reminderButton: {
    backgroundColor: "#0033cc",
    fontSize: 14,
    textTransform: "capitalize"
  },
  ownTruck: {
    backgroundColor: '#0033cc',
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 4,
    paddingTop: 1,
    paddingBottom: 3,
    letterSpacing: '1px',
    marginLeft: 16
  },
  marketTruck: {
    backgroundColor: '#e86825',
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 4,
    paddingTop: 1,
    paddingBottom: 3,
    letterSpacing: '1px',
    marginLeft: 16
  },


  divTripListing: {
    display: 'flex', alignItems: 'center', justifyContent: 'flex-end'
  },
  divDateTripListing: {
    color: '#9ea0a5',
    fontSize: 13,
    textAlign: 'start',
    marginTop: '-20px',
    marginBottom: 2,
  },
  divTripStatusTripListing: {
    color: '#9ea0a5',
    fontSize: 13,
    textAlign: 'start',
    marginTop: '-20px',
    marginBottom: 2,
  },
  mtV2TripListing: {
    display: 'flex',
  },
  doneIcon: {
    color: '#00875a',
    fontSize: 16,
    marginTop: -2,
    marginLeft: 8
  },


  divAlignV1: {
    display: 'flex',
    alignItems: 'center'
  },
  fwBold: {
    fontWeight: 'bold'
  },
  doneV1: {
    color: '#008556',
    fontSize: '14px !important',
    marginLeft: 8,
    marginRight: 8
  },
  divTranstNo: {
    fontSize: '14px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.43,
    letterSpacing: 'normal',
    color: 'rgba(11, 19, 35, 0.5)',
  },
  divTranstNoV1: {
    fontSize: '14px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.43,
    letterSpacing: 'normal',
    color: 'rgba(11, 19, 35, 0.5)',
    marginLeft: '10px'
  },
  dotV1: {
    fontSize: '10px !important',
    color: '#d8d8d8',
    marginLeft: '8px',
    marginRight: '6px'
  },
  tripInfo: {
    fontWeight: 500,
    lineHeight: 1.43,
    letterSpacing: 'normal',
    color: 'rgba(11, 19, 35, 0.5)'
  },
  divVehicleNumber: {
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    '& :nth-last-child(2)': {
      marginLeft: 6
    },
    '& :last-child': {
      marginLeft: 6,
      color: '#0033cc'
    }
  },
  thTruckRightAlign: {
    backgroundColor: '#E3E8FD',
    border: '1px solid #dfe2e5',
    paddingBottom: 10,
    paddingTop: 10,
    textAlign: 'end',
    paddingLeft: 16,
    paddingRight: 16,
    position: 'sticky',
    zIndex: 100,
    top: '-1px !important'
  },
  fwNormal: {
    fontWeight: 'normal'
  },
  listEmptyState: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: "center"
  },
  listEmptyStateImgShop: {
    marginTop: 75,
    width: 276,
    height: 459
  },
  listEmptyStateDescSingle: {
    fontSize: 20,
    color: "#000",
    marginTop: 60,
    textAlign: 'center'
  },
  listEmptyStateActions: {
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  shopBalanceDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  shopBalanceDue: {
    fontSize: 14,
    fontWeight: 600,
    color: "#de1c22"
  },
  shopBalanceAdvance: {
    fontSize: 14,
    fontWeight: 600,
    color: "#00875a"
  },
  dotSeperator: {
    fontSize: 8,
    color: '#a8b0bd',
    marginLeft: 8,
    marginRight: 8
  },
  shopBalanceDesc: {
    fontSize: 14,
    fontWeight: 600,
    color: "#6b778c"
  },
  shopBalance: {
    fontSize: 14,
    fontWeight: 600,
    color: "#0b1323"
  },
  shopActions: {
    display: 'flex',
  },
  shopActionEdit: {
    fontSize: 14,
    fontWeight: 600,
    color: "#0b1323"
  },
  shopActionDelete: {
    fontSize: 14,
    fontWeight: 600,
    color: "#0b1323"
  },
  shopCreditButton: {
    backgroundColor: '#de1c22', color: 'white', textTransform: 'none', paddingTop: '8px', paddingBottom: '7px', paddingLeft: '18px', paddingRight: '18px', fontWeight: 300, borderRadius: '4px', marginRight: '16px',
    "&:hover": {
      backgroundColor: '#de1c22'
    }
  },
  shopPaymentButton: {
    backgroundColor: '#00875a', color: 'white', textTransform: 'none', paddingTop: '8px', paddingBottom: '7px', paddingLeft: '18px', paddingRight: '18px', fontWeight: 300, borderRadius: '4px', marginRight: '16px',
    "&:hover": {
      backgroundColor: '#00875a'
    }
  },
  addShopCta: {
    backgroundColor: '#5170f0',
    borderRadius: 4,
    border: 0,
    width: 344,
    color: 'white',
    height: 56,
    padding: '7px 26px 7px 12px',
    margin: '0 16px',
    fontWeight: 600,
    textTransform: 'uppercase',
    '&:hover': {
      backgroundColor: '#5170f0'
    }
  },
  mrV1: {
    marginRight: 10
  },
  singleDriverSendMoney: {
    padding: '8px 16px 8px 16px',
    borderRadius: '4px',
    backgroundColor: '#0033cc',
    color: 'white',
    fontWeight: 600,
    textTransform: 'none',
    marginLeft: 16,
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  },
  mlV5: {
    marginLeft: 8
  },
  divAlignV3: {
    display: 'flex',
    alignItems: 'center'
  },
  divAlignV4: {
    display: 'flex !important',
    alignItems: 'center !important'
  },
  buttonSendMoney: {
    textTransform: 'none',
    backgroundColor: '#0033cc',
    color: 'white',
    borderRadius: '4px',
    fontWeight: 300,
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: 16,
    paddingRight: 16,
    marginLeft: 24,
    '&:hover': {
      backgroundColor: '#0033cc'
    }
  },
  pendingIcon: {
    fontSize: 16,
    marginLeft: 8,
    marginRight: 8
  },
  divPaymentStatus: {
    fontSize: 12,
    fontWeight: 500,
    color: '#ed8c46',
    marginLeft: '10px'
  },
  singleDriverPdfButton: {
    padding: '8px 16px 8px 16px',
    borderRadius: '4px',
    backgroundColor: '#f27f36',
    color: 'white',
    fontWeight: 600,
    textTransform: 'none',
    marginLeft: 16,
    '&:hover': {
      backgroundColor: '#f27f36'
    }
  },
  singleShopPdfButton: {
    padding: '8px 16px 8px 16px',
    borderRadius: '4px',
    backgroundColor: '#f27f36',
    color: 'white',
    fontWeight: 600,
    textTransform: 'none',
    marginLeft: 16,
    '&:hover': {
      backgroundColor: '#f27f36'
    }
  },

}));
export default useStyles;